import React, { useState, useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
const API = `${BACKEND_URL}/api`;

export default function ProtectedRoute({ children }) {
  const location = useLocation();
  const [isAuthenticated, setIsAuthenticated] = useState(
    location.state?.user ? true : null
  );
  const [user, setUser] = useState(location.state?.user || null);
  const [isPending, setIsPending] = useState(false);

  useEffect(() => {
    if (location.state?.user) {
      // Check if user is pending even when passed via state
      if (location.state.user.status === 'pending' || location.state.user.status === 'rejected') {
        setIsPending(true);
      }
      return;
    }

    const checkAuth = async () => {
      try {
        const token = localStorage.getItem('authToken');
        if (token) {
          axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        }

        const response = await axios.get(`${API}/auth/me`, {
          withCredentials: true
        });
        if (response.status === 200) {
          const userData = response.data;
          setUser(userData);

          // Check user status
          if (userData.status === 'pending' || userData.status === 'rejected') {
            setIsPending(true);
          } else {
            setIsAuthenticated(true);
          }
        }
      } catch (error) {
        if (error.response?.status === 403) {
          // User exists but is pending/rejected
          setIsPending(true);
        } else {
          setIsAuthenticated(false);
        }
      }
    };

    checkAuth();
  }, [location.state]);

  if (isPending) {
    return <Navigate to="/pending-approval" state={{ user }} replace />;
  }

  if (isAuthenticated === null) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-solid border-current border-r-transparent"></div>
          <p className="mt-4 text-sm text-muted-foreground">Verificando autenticação...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  return React.cloneElement(children, { user });
}